import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { FormService } from '../shared/form.service';
import { NX_MODAL_DATA, NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { OfferService } from '../shared/offer.service';
import { FormBuilder, Validators } from '@angular/forms';
import { catchError, map, switchMap, switchMapTo, takeUntil } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { ProposalService } from '../shared/proposal.service';
import { TrackService } from '../services/track.service';

@Component({
  selector: 'app-person-details-modal',
  templateUrl: './person-details-modal.component.html',
  styleUrls: ['./person-details-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PersonDetailsModalComponent implements OnInit, OnDestroy {
  currentForm;
  mainForm;
  componentAgentRef: NxModalRef<PersonDetailsModalComponent>;
  phoneCodes =[] ;
  phoneMask = '00 000 0000';
  phonePattern;
  phoneSeparator = [' '];
  deactivateMask = false;
  private sendErrorClicks$ = new Subject<void>();
  private onDestroy$ = new Subject<void>();

  constructor(
    public proposalService: ProposalService,
    public formService: FormService,
    public offerService: OfferService,
    public trackService: TrackService,
    @Inject(NX_MODAL_DATA) public data: any,
    public dialogService: NxDialogService,
    public formBuilder: FormBuilder,
    public router: Router,
    public sharedService: SharedService) {
    if (this.data.agent) {
      this.mainForm = this.formService.getMainForm();
      const a = this.mainForm.getRawValue();
      const {
        n_1NSP_Premium,
        n_2NSP_Premium,
        n_3NSP_Premium,
        n_1NSP_PremiumCurr2,
        n_2NSP_PremiumCurr2,
        n_3NSP_PremiumCurr2,
        cityName,
        purpose,
        yearOfConstruction,
        street,
        claimsExists,
        recommendedPackage,
        discount1,
        nErr_Code,
        status,
        contractProcessState,
        currency,
        doubleVisualization,
        propertyCategory,
        propertySubcategory,
        postCode,
        area,
        insSumOutsideObjects,
        insSumSpecificObjects,
        isEarthQuakeIncluded,
        isGlassIncluded,
        isGoMaxIncluded,
        isDeductibleIncluded,
        isRenewed,
        commissionDiscount,
        immovableinsuranceSum,
        movableinsuranceSum,
        topComfort,
        topExtra,
        topMax,
        bottomComfortOne,
        bottomExtraOne,
        bottomMaxOne,
        bottomComfortTwo,
        bottomExtraTwo,
        bottomMaxTwo,
        bottomComfortFour,
        bottomExtraFour,
        bottomMaxFour,
        topComfortCurr2,
        topExtraCurr2,
        topMaxCurr2,
        bottomComfortOneCurr2,
        bottomExtraOneCurr2,
        bottomMaxOneCurr2,
        bottomComfortTwoCurr2,
        bottomExtraTwoCurr2,
        bottomMaxTwoCurr2,
        bottomComfortFourCurr2,
        bottomExtraFourCurr2,
        bottomMaxFourCurr2,
        glass,
        goLimit,
        selfParticipation
      } = this.mainForm.getRawValue();
      // debugger;
      this.currentForm = this.formBuilder.group({
        saveOfferOwnerData: this.formBuilder.group({
          firstName: ['', [Validators.required]],
          lastName: ['', [Validators.required]],
          phoneNumber: ['', Validators.required],
          countryCode:['', Validators.required],
          n_1NSP_Premium,
          n_2NSP_Premium,
          n_3NSP_Premium,
          n_1NSP_PremiumCurr2,
          n_2NSP_PremiumCurr2,
          n_3NSP_PremiumCurr2,
          cityName,
          purpose,
          yearOfConstruction,
          street,
          claimsExists,
          recommendedPackage,
          discount1,
          nErr_Code,
          status,
          contractProcessState,
          currency,
          doubleVisualization,
          propertyCategory,
          propertySubcategory,
          postCode,
          area,
          insSumOutsideObjects,
          insSumSpecificObjects,
          isEarthQuakeIncluded,
          isGlassIncluded,
          isGoMaxIncluded,
          isDeductibleIncluded,
          isRenewed,
          commissionDiscount,
          immovableinsuranceSum,
          movableinsuranceSum,
          topComfort,
          topExtra,
          topMax,
          bottomComfortOne,
          bottomExtraOne,
          bottomMaxOne,
          bottomComfortTwo,
          bottomExtraTwo,
          bottomMaxTwo,
          bottomComfortFour,
          bottomExtraFour,
          bottomMaxFour,
          topComfortCurr2,
          topExtraCurr2,
          topMaxCurr2,
          bottomComfortOneCurr2,
          bottomExtraOneCurr2,
          bottomMaxOneCurr2,
          bottomComfortTwoCurr2,
          bottomExtraTwoCurr2,
          bottomMaxTwoCurr2,
          bottomComfortFourCurr2,
          bottomExtraFourCurr2,
          bottomMaxFourCurr2,
          glass,
          goLimit,
          selfParticipation
        })
      });
    } else {
      this.currentForm = this.formService.currentForm;
    }
  }

  get countryCode() {
    return this.currentForm.controls.saveOfferOwnerData.get('countryCode')
  }
  get mobilePhone() {
    return this.currentForm.controls.saveOfferOwnerData.get('phoneNumber')
  }

  ngOnInit(): void {

    this.sharedService.getPhoneCodes().subscribe((res) => {
      this.phoneCodes=res.map(function (el:any) { return el.value; });
    });

    if (!this.data.agent) {
      this.trackService.pushEventTracking('text', 'Save quote')

      this.currentForm.controls.saveOfferOwnerData.get('firstName').value = this.currentForm.controls.firstFirstName.value;

      if(this.currentForm.controls.firstCountryCode.value && this.currentForm.controls.firstPhoneNumber.value)
      this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').value = this.currentForm.controls.firstPhoneNumber.value;
      this.currentForm.controls.saveOfferOwnerData.get('countryCode').value = this.currentForm.controls.firstCountryCode.value;

      if (this.currentForm.controls.policyholderData.controls.email.value) {
        this.currentForm.controls.saveOfferOwnerData.get('email').value = this.currentForm.controls.policyholderData.controls.email.value;
      }
    }
    if (this.data.agent) {
      this.trackService.pushEventTracking('text', 'Call agent')

      this.currentForm.controls.saveOfferOwnerData.get('firstName').value = this.formService.currentForm.controls.firstFirstName.value;

      if(this.formService.currentForm.controls.firstCountryCode.value &&this.formService.currentForm.controls.firstPhoneNumber.value)
      this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').value =this.formService.currentForm.controls.firstPhoneNumber.value;
      this.currentForm.controls.saveOfferOwnerData.get('countryCode').value = this.formService.currentForm.controls.firstCountryCode.value;

      this.sendErrorClicks$
        .pipe(
          takeUntil(this.onDestroy$),
          switchMapTo(this.sharedService.errorState$),
          map(payload => {
            this.sharedService.loadingSpinner = true;
            payload = payload || {};
            Object.assign(payload, this.currentForm.controls.saveOfferOwnerData.getRawValue())
            payload.firstName = this.currentForm.controls.saveOfferOwnerData.get('firstName').value;
            // payload.lastName = this.currentForm.controls.saveOfferOwnerData.get('lastName').value;
            payload.mobile = this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').value;

            delete payload.mobilePhone;
            return payload;
          }),
          switchMap(payload => this.sharedService.sendError(payload)
            .pipe(
              catchError(error => {
                this.sharedService.loadingSpinner = false;
                return of(true);
              })
            )
          )
        ).subscribe(_ => {
          this.sharedService.loadingSpinner = false;
          this.dialogService.closeAll();
          this.trackService.pushEventTracking('text', 'Thank you – call agent')
          this.componentAgentRef = this.dialogService.open(PersonDetailsModalComponent, {
            data: {
              heading: 'error.thankyou',
              subHeading: 'error.headingAgent',
              //image: 'image',
              image: 'sent'
            }, showCloseIcon: true
          });
          return true;
          //return this.router.navigate(['callAgent']);
        });
    }

    this.currentForm.controls.saveOfferOwnerData.get('countryCode').valueChanges.subscribe((mobileCode) => {
      if (mobileCode !== '+359') {
        this.deactivateMask = true;
        this.phonePattern = '[0-9]{0,15}'
        this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').updateValueAndValidity();
      } else {
        this.deactivateMask = false;
        this.phonePattern='^((?!(0))[0-9]{9})$'
        this.currentForm.controls.saveOfferOwnerData.get('phoneNumber').updateValueAndValidity();
      }

    });
  }



  saveOffer(calculatedPremiums) {
    if (this.currentForm.controls.saveOfferOwnerData.controls.firstName.status === 'VALID' && this.currentForm.controls.saveOfferOwnerData.controls.email.status === 'VALID' 
    && this.currentForm.controls.saveOfferOwnerData.controls.firstName.value !== '' && this.currentForm.controls.saveOfferOwnerData.controls.email.value !== '') {
    this.offerService.saveOffer(calculatedPremiums, this.data.productProposals, this.data.selectedItem, () => {
      this.dialogService.closeAll();
      this.trackService.pushEventTracking('text', 'Thank you – save quote')
      this.componentAgentRef = this.dialogService.open(PersonDetailsModalComponent, {
        data: {
          heading: 'error.thankyou',
          subHeading: 'error.thankyouHeading',
          //image: 'image',
          image: 'sent'
        }, showCloseIcon: true
      });
    });
  }

  }

  sendError() {
    if (this.currentForm.valid) {
      this.sendErrorClicks$.next();
    }
    /*this.dialogService.closeAll();
    this.componentAgentRef = this.dialogService.open(PersonDetailsModalComponent, {
      data: {
        title: 'error.title',
        heading: 'error.headingAgent',
        errorMessage: 'error.errorMessage',
        btnCloseText: 'callAgent.btnOkText',
        agent: true
      }, showCloseIcon: true
    });*/
  }

  close() {
    this.dialogService.closeAll();
  }


  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
